import { environment } from '../environments/environment';

import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ApiService} from './shared/services/api.service';
import { StorageService } from './shared/services/storage.service';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { AppComponent } from './app.component';
import { StartComponent } from './start/start.component';
import { CardComponent } from './remote/card/card.component';
import { FilterCardsPipe } from './shared/services/filter-service.pipe';
import { QuestionComponent } from './remote/card/question/card-question.component';
import { AnswerComponent } from './remote/card/answer/card-answer.component';
import { GameComponent } from './remote/game/game.component';
import { LocalStorageModule } from '@ngx-pwa/local-storage';

import { SocketService } from './shared/services/socket.service';
import { DigiModule } from './digi/digi.module';
import { RemoteModule } from './remote/remote.module';
import { SharedModule } from './shared/shared.module';
import { GameService } from './shared/services/game.service';
import { GroupsService } from './shared/services/groups-service';

@NgModule({
  declarations: [
    AppComponent,
    StartComponent,
    CardComponent,
    FilterCardsPipe,
    QuestionComponent,
    AnswerComponent,
    GameComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('/ngsw-worker.js', {enabled: environment.production}),
    LocalStorageModule,
    FormsModule,
    ReactiveFormsModule,
    RemoteModule,
    DigiModule,
    SharedModule

  ],
  providers: [SocketService, ApiService, StorageService, GameService, GroupsService, { provide: LOCALE_ID, useValue: 'nl' } ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts